import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, getProduct, ShoppingBagComponent, InteriorComponent, FrontLayoutComponent, HideFromAssemblyInstructionsComponent, OuterMeasurementsComponent, SlidingDoorComponent, TopPanelComponent, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, OrganizerComponent, DistanceMeasurementComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import PlatsaFrontComponent from '../components/PlatsaFrontComponent';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
import NonDuplicatableComponent from '@inter-ikea-storageone/range/src/core-api/components/NonDuplicatableComponent';
export const platsaComponentResolver = (_coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.PLATSA_FRAME,
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES,
        ProductType.PLATSA_SHELF,
        ProductType.PLATSA_SHOE_SHELF,
        ProductType.PLATSA_MULTIUSE_HANGER,
        ProductType.PLATSA_WIRE_BASKET,
        ProductType.PLATSA_WIRE_BASKET_RAIL,
        ProductType.PLATSA_OUTSIDE_HOOK,
        ProductType.PLATSA_TOP,
        ProductType.PLATSA_LEG,
        ProductType.PLATSA_SUSPENSION_RAIL,
        ProductType.PLATSA_DOOR_FRONT,
        ProductType.PLATSA_HINGE,
        ProductType.PLATSA_SLIDING_DOOR_FRONT,
        ProductType.PLATSA_SLIDING_DOOR_RAIL,
        ProductType.PLATSA_SLIDING_DOOR_HANDLE,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.PLATSA_CLOTH_RAIL_40,
        ProductType.PLATSA_CLOTH_RAIL_55_RAIL,
        ProductType.PLATSA_RAIL_STRIP,
        ProductType.PLATSA_DRAWER_FRONT,
        ProductType.PLATSA_DRAWER_INSERT,
        ProductType.PLATSA_HOOK,
        ProductType.PLATSA_SHELF_ORGANIZER,
        ProductType.PLATSA_CLOTH_RAIL_ORGANIZER,
        ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER,
        ProductType.PLATSA_INNER_LIGHT,
        ProductType.LIGHT_CONTROLER,
        ProductType.LIGHT_CORD,
        ProductType.LIGHT_DRIVER,
        ProductType.CLOTH_HANGERS
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.PLATSA_FRAME,
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES,
        ProductType.PLATSA_DRAWER_ASM,
        ProductType.PLATSA_SHELF,
        ProductType.PLATSA_SHOE_SHELF,
        ProductType.PLATSA_WIRE_BASKET_ASM,
        ProductType.PLATSA_MULTIUSE_HANGER,
        ProductType.PLATSA_OUTSIDE_HOOK,
        ProductType.PLATSA_LEG,
        ProductType.PLATSA_TOP,
        ProductType.PLATSA_HINGE_DOOR_ASM,
        ProductType.PLATSA_SC_HINGE_DOOR_ASM,
        ProductType.PLATSA_SLIDING_DOOR_ASM,
        ProductType.HANDLE,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.PLATSA_CLOTH_RAIL_40,
        ProductType.PLATSA_CLOTH_RAIL_55,
        ProductType.PLATSA_CLOTH_RAIL_55_W_HOOKS_ASM,
        ProductType.PLATSA_RAIL_STRIP_W_HOOKS_ASM,
        ProductType.PLATSA_SHELF_ORGANIZER,
        ProductType.PLATSA_CLOTH_RAIL_ORGANIZER,
        ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER,
        ProductType.PLATSA_INNER_LIGHT
    ]);
    const isInterior = isOfType([
        ProductType.PLATSA_SHELF,
        ProductType.PLATSA_SHOE_SHELF,
        ProductType.PLATSA_WIRE_BASKET_ASM,
        ProductType.PLATSA_MULTIUSE_HANGER,
        ProductType.PLATSA_CLOTH_RAIL_40,
        ProductType.PLATSA_CLOTH_RAIL_55,
        ProductType.PLATSA_DRAWER_ASM,
        ProductType.PLATSA_RAIL_STRIP_W_HOOKS_ASM
    ]);
    const isRegularFrame = isOfType([ProductType.PLATSA_FRAME]);
    const isOpenFrame = isOfType([
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES
    ]);
    const isDrawer = isOfType([ProductType.PLATSA_DRAWER_ASM]);
    const isHingedDoor = isOfType([
        ProductType.PLATSA_HINGE_DOOR_ASM,
        ProductType.PLATSA_SC_HINGE_DOOR_ASM
    ]);
    const isSlidingDoor = isOfType([ProductType.PLATSA_SLIDING_DOOR_ASM]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.PLATSA_FRAME,
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES,
        ProductType.PLATSA_LEG,
        ProductType.PLATSA_TOP,
        ProductType.PLATSA_DOOR_FRONT,
        ProductType.PLATSA_DRAWER_FRONT,
        ProductType.PLATSA_SLIDING_DOOR_FRONT
    ]);
    const shouldBeIncludedInInnerMeasurement = isOfType([
        ProductType.PLATSA_SHELF,
        ProductType.PLATSA_SHOE_SHELF,
        ProductType.PLATSA_WIRE_BASKET_ASM,
        ProductType.PLATSA_MULTIUSE_HANGER,
        ProductType.PLATSA_CLOTH_RAIL_40,
        ProductType.PLATSA_CLOTH_RAIL_55
    ]);
    const isOrganizer = isOfType([
        ProductType.PLATSA_SHELF_ORGANIZER,
        ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER,
        ProductType.PLATSA_CLOTH_RAIL_ORGANIZER
    ]);
    const isFront = isOfType([ProductType.PLATSA_DOOR_FRONT, ProductType.PLATSA_DRAWER_FRONT]);
    const isHandle = isOfType([ProductType.HANDLE, ProductType.KNOB, ProductType.EDGE_HANDLE]);
    const shouldBeRemovedFromAssemblyImages = isOfType([
        ProductType.PLATSA_HINGE_DOOR_ASM,
        ProductType.PLATSA_DOOR_FRONT,
        ProductType.PLATSA_SC_HINGE_DOOR_ASM,
        ProductType.PLATSA_SLIDING_DOOR_ASM,
        ProductType.PLATSA_DRAWER_FRONT,
        ProductType.PLATSA_SHELF_ORGANIZER,
        ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER,
        ProductType.PLATSA_CLOTH_RAIL_ORGANIZER
    ]);
    const isTopPanel = isOfType([ProductType.PLATSA_TOP]);
    const shouldNotBeSelectable = (entity) => {
        return isHandle(entity) || isTopPanel(entity);
    };
    const shouldNotBeDraggable = (entity) => {
        return isHingedDoor(entity) || isSlidingDoor(entity) || isTopPanel(entity) || isDrawer(entity);
    };
    const isNonDuplicatable = isOfType([ProductType.PLATSA_LEG, ProductType.PLATSA_TOP]);
    const hideInSeeThroughEntitySystem = isOfType([
        ProductType.PLATSA_FRAME,
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES
    ]);
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (isRegularFrame(entity) && product) {
                entity.addComponent(new FrontLayoutComponent(product.meta?.defaultFrontLayout || ''));
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isRegularFrame(entity) || isOpenFrame(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldBeIncludedInInnerMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
            }
            if (shouldNotBeSelectable(entity)) {
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (shouldNotBeDraggable(entity)) {
                entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
            if (isFront(entity)) {
                entity.addComponent(new PlatsaFrontComponent());
            }
            if (isSlidingDoor(entity)) {
                entity.addComponent(new SlidingDoorComponent());
            }
            if (isTopPanel(entity)) {
                entity.addComponent(new TopPanelComponent());
            }
            if (isOrganizer(entity)) {
                entity.addComponent(new OrganizerComponent());
            }
            if (isNonDuplicatable(entity)) {
                entity.addComponent(new NonDuplicatableComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=platsaComponentResolver.js.map